import React from 'react';
import { Spin, Table, Tooltip, Button, Icon, Col, Row, Select, Modal, Input } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import CatalogosRequest from '../../services/Catalogos';
import FormAsignacion from './FormAsignacion';
import FormCalendario from './FormCalendario';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';
const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de calendario pedidos
 */
export default class CalendarioPedidos extends BaseComponent {
    state = {
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrSegmentos: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        segmentoSelected: null,
        drivesSelected: [],
        arrCategorias: [],
        arrCategoriasCopy: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalCategorias: false,
        modalCalendario: false,
        disableDeleteFilters: true,
        disableApplyFilters: true,
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                if (["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) {
                    return CatalogosRequest.ListarSegmentosConfigurados()
                } else {
                    return Promise.resolve({ data: [] });
                }
            })
            .then(response => {
                state.arrSegmentos = response.data;
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta para cargar las categorías
     */
    cargarCategoriasCalendario = () => {
        let state = { ...this.state }
        var sitios;
        if (state.drivesSelected.length) {
            sitios = state.drivesSelected;
        } else {
            sitios = [];
            for (let index = 0; index < state.arrDrives.length; index++) {
                const element = state.arrDrives[index];
                sitios.push(element.id)
            }
        }

        this.setState({ cargando: true, disableApplyFilters: true, disableDeleteFilters: true }, () => {
            CategoriasRequest.ListarCategoriaCalendario({ 'sitios': sitios })
                .then(response => {
                    state.arrCategorias = response.data
                    state.arrCategoriasCopy = response.data
                    state.cargando = false
                    state.disableApplyFilters = false;
                    state.disableDeleteFilters = false;
                    this.setState(state)

                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar las categorías",
                        "Error al listar categorías",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrCategoriasCopy = state.arrCategorias
        if (value) {
            arrCategoriasCopy = arrCategoriasCopy.filter(obj => {
                return sanitizerTexto(value, obj.categoria_nombre)
                    || sanitizerTexto(value, obj.sitio.nombre)
            })
        }
        state.arrCategoriasCopy = arrCategoriasCopy
        this.setState(state);
    }

    /**
     * Función para mostar el modal de categorización
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        let state = { ...this.state }
        state.tipo_modal === 'uno' ? state.modalCategorias = true : state.modalCalendario = true
        this.setState(state)
    }

    /**
     * Función para esconder modal de categorización
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.modalCategorias = false;
        state.modalCalendario = false;
        state.categoriaSelected = null;
        this.setState(state)
        if (value) this.cargarCategoriasCalendario()
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.disableApplyFilters = true
        state.arrCategorias = [];
        state.arrCategoriasCopy = [];
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.disableApplyFilters = true
        state.arrCategorias = [];
        state.arrCategoriasCopy = [];
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.arrCategorias = [];
        state.arrCategoriasCopy = [];
        state.disableApplyFilters = true;
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
        }

        const role = localStorage.getItem("role");
        if (role !== "Administrador" && role !== "SuperAdmin") {
            CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                state.arrDrives = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                    "Error al cargar drives",
                    false
                )
            });
        }
        this.setState(state)
    }


    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.filterText = "";
        state.disableApplyFilters = true
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value
            if (["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) {
                CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los puntos de venta de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.disableApplyFilters = false;
        if (value === undefined) {
            state.drivesSelected = [];
        } else {
            state.drivesSelected = value
        }

        this.setState(state)
    }

    /**
     * Comportamiento al confirmar eliminar clendario
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar el calendario de la categoría?</b> Se borrará el calendario de la categoría.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-calendario-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-calendario-form',
            },
            onOk: () => {
                this.setState({ cargando: true })
                CategoriasRequest.EliminarCategoriaCalendario(this.state.categoriaSelected.id)
                    .then(response => {
                        openNotification(
                            "Se ha eliminado correctamente el calendario de la categoría.",
                            "Calendario eliminado correctamente",
                            true
                        )
                        this.cargarCategoriasCalendario()
                    })
                    .catch(err => {
                        this.setState({cargando: false})
                        openNotification(
                            "Ha ocurrido un error al eliminar el calendario de la categoría.",
                            "Error al eliminar calendario",
                            false
                        )
                    })
            },
        });
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.segmentoSelected = null;
        state.drivesSelected = [];
        state.filterText = "";
        state.arrCategorias = [];
        state.arrCategoriasCopy = [];
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    render() {
        const columnasCategorias = [
            {
                title: "Categoría",
                dataIndex: "categoria_nombre",
                key: "categoria_nombre"
            },
            {
                title: "Tipo modelo",
                dataIndex: "tipo_modelo",
                key: "tipo_modelo"
            },
            {
                title: "Punto de venta",
                dataIndex: "sitio.nombre",
                key: "sitio.nombre"
            },
            {
                title: "Plaza",
                dataIndex: "sitio.plaza_nombre",
                key: "sitio.plaza_nombre"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <div>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Ver calendario"}>
                                    <Button
                                        id="boton-ver-detalle-categoria-row-modulo"
                                        icon="eye"
                                        className="btnVerCrearGuardar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: "ver",
                                                tipo_modal: 'dos'
                                            }, this.showModal)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={localStorage.getItem("role") === 'Supervisor de Operaciones Drive' ? 'display-none' : ''} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Editar calendario"}>
                                    <Button
                                        id="boton-editar-categoria-row-modulo"
                                        icon="edit"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: "editar",
                                                tipo_modal: 'dos'
                                            }, this.showModal)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span className={localStorage.getItem("role") === 'Supervisor de Operaciones Drive' ? 'display-none' : ''} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Eliminar calendario"}>
                                    <Button
                                        id="boton-eliminar-categoria-row-modulo"
                                        icon="delete"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record
                                            }, this.showConfirmDelete)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ]

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo calendario de pedidos"
                extra={
                    <div>
                        <Button
                            className={localStorage.getItem("role") === 'Supervisor de Operaciones Drive' ? 'display-none' : ''}
                            type="primary"
                            id="boton-asignar-categoria-calendario-modulo"
                            disabled={!this.state.drivesSelected.length}
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'uno' }, this.showModal)

                            }}
                        >
                            Asignar categoría
                        </Button>
                    </div>
                }
            >

                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected === null ? true : false}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null ? true : false}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col className={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={8}>
                                <div className="center">Segmento:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione un segmento">
                                    <Select
                                        id="select-segmento-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeSegmento}
                                        value={this.state.segmentoSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? 8 : 16}>
                                <div className="center">Punto de venta:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione punto de venta">
                                    <Select
                                        id="select-drive-calendario-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-variables"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '80%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cargarCategoriasCalendario}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-variables"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '80%', marginBottom: "30px", marginTop: '1.85em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row gutter={12} className={this.state.arrCategorias.length ? '' : 'display-none'}>
                        <Col span={12} >
                                <Tooltip placement="top" title="Buscar categorías">
                                    <div className="center">Buscar categorías:</div>
                                    <Input
                                        id="input-categorias-calendario-busqueda"
                                        type="text"
                                        maxLength={80}
                                        autoFocus
                                        value={this.state.filterText}
                                        placeholder="Buscar por Categoría / Punto de venta"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={categoria => categoria.id}
                            columns={columnasCategorias}
                            dataSource={this.state.arrCategoriasCopy}
                            pagination={{ showTitle: false }}
                        />
                    </Spin>
                </div>
                <FormAsignacion
                    esconderModal={this.esconderModal}
                    visible={this.state.modalCategorias}
                    tipo_modal={this.state.tipo_modal}
                    modo={this.state.modo}
                    drives_selected={this.state.drivesSelected}
                >
                </FormAsignacion>
                <FormCalendario
                    esconderModal={this.esconderModal}
                    visible={this.state.modalCalendario}
                    tipo_modal={this.state.tipo_modal}
                    modo={this.state.modo}
                    categoria_selected={this.state.categoriaSelected}
                >
                </FormCalendario>
            </ResponsiveCard>
        )
    }
}